import RestClient from './RestClient'

const ENTRY_POINT = '/user'
export default class UserService {
  restClient: RestClient

  constructor(restClient: RestClient) {
    this.restClient = restClient
  }

  requestDeposit(form: IDepositRequestInfo): Promise<IDepositRequest> {
    return this.restClient.post(ENTRY_POINT + `/deposit`, form)
  }

  doRollByUser(rollRequest: IRollRequestInfo): Promise<IRollRequest> {
    return this.restClient.post(ENTRY_POINT + `/do-roll`, rollRequest)
  }

  getUser(): Promise<IUser> {
    return this.restClient.get(ENTRY_POINT + '/')
  }

  updateSteam(steamId: string): Promise<string> {
    return this.restClient.post(ENTRY_POINT + '/update-steam', undefined, {steamId: steamId})
  }

  updateOfferLink(offerLink: string): Promise<string> {
    return this.restClient.post(ENTRY_POINT + '/update-offer-url', undefined, {offerLink: offerLink})
  }

  updatePassword(oldPassword: string, newPassword: string): Promise<boolean> {
    return this.restClient.post(ENTRY_POINT + '/update-password',
                                undefined, {oldPassword: oldPassword, newPassword: newPassword})
  }

  notifyDeposit(depRequest: IDepositRequest): Promise<boolean> {
    return this.restClient.post(ENTRY_POINT + '/notify-dep', depRequest)
  }

  getCardInfo(): Promise<ICardInfo[]> {
    return this.restClient.get(ENTRY_POINT + '/get-cards')
  }

  getNapTheCardInfo(): Promise<INapTheCardInfo[]> {
    return this.restClient.get(ENTRY_POINT + '/get-napthe-cards')
  }

  checkoutCard(depCard: IDepositCardInfo): Promise<IDepositCardInfo> {
    return this.restClient.post(ENTRY_POINT + '/checkout-card', depCard)
  }

  checkoutNganLuong(checkoutInfo: INLCheckoutInfo): Promise<INLCheckoutResult> {
    return this.restClient.post(ENTRY_POINT + '/checkout-nganluong', checkoutInfo)
  }

  checkNganLuong(token: string): Promise<boolean> {
    return this.restClient.get(ENTRY_POINT + '/check-nganluong', {token: token})
  }

  exchangeItem(exchangeRequest: IExchangeRequestInfo): Promise<IRollResult> {
    return this.restClient.post(ENTRY_POINT + '/do-exchange', exchangeRequest)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/UserService.ts